import { render, staticRenderFns } from "./MainFrame.vue?vue&type=template&id=6286f0cc&scoped=true&"
import script from "./MainFrame.vue?vue&type=script&lang=js&"
export * from "./MainFrame.vue?vue&type=script&lang=js&"
import style0 from "./MainFrame.vue?vue&type=style&index=0&id=6286f0cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6286f0cc",
  null
  
)

export default component.exports